import { useFormik } from 'formik';

import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import Modal from '../../../modals/components/modal/Modal';
import { modalsActions } from '../../../modals/modalsSlice';
import { createUserThunk, updateUserThunk } from '../../services/usersThunks';
import { userFormSchema, userInitForm } from '../userForm/formDatas';
import UserForm from '../userForm/UserForm';
import styles from './userFormModal.module.scss';

interface IUserFormModalProps {
  user: IUser | null;
}
function UserFormModal({ user }: IUserFormModalProps) {
  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(modalsActions.createOrUpdateUser({ open: false, entity: null }));
  };

  const formik = useFormik({
    initialValues: userInitForm(user),
    validationSchema: userFormSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      if (user) {
        dispatch(updateUserThunk({ idIri: user.idIri, body: values }));
      } else {
        dispatch(createUserThunk({ body: { ...values } }));
      }

      closeModal();
    },
  });

  return (
    <Modal>
      <div className={styles.userFormModal}>
        <h2>+ Ajouter un nouveau collaborateur</h2>
        <div className={styles.content}>
          <UserForm formik={formik} isNew />
          <div className={styles.btnContainer}>
            <Button
              btnType="button"
              btnContent="ANNULER"
              handleClick={closeModal}
              textColor="violet"
              bgColor="white"
              borderColor="grey"
            />
            <Button
              btnType="submit"
              btnContent="VALIDER"
              handleClick={formik.handleSubmit}
              primary
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UserFormModal;
